import getResizeEventEmitter from './getResizeEventEmitter';
import eventName from './store/schema/eventName';

export default function trigger(key: string = '', targetWindow?: Window): void {
    getResizeEventEmitter(key, targetWindow).emit(eventName);
}
